import { gzip, ungzip } from "pako";
import { createCoreError } from "../errors/coreError.js";
import { decodeBase64Url, encodeBase64Url } from "./base64url";

function utf8Encode(value) {
  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(value);
  }

  if (typeof Buffer !== "undefined") {
    return new Uint8Array(Buffer.from(value, "utf8"));
  }

  throw createCoreError("core.errors.utf8EncoderUnavailable");
}

function utf8Decode(bytes) {
  if (typeof TextDecoder !== "undefined") {
    return new TextDecoder().decode(bytes);
  }

  if (typeof Buffer !== "undefined") {
    return Buffer.from(bytes).toString("utf8");
  }

  throw createCoreError("core.errors.utf8DecoderUnavailable");
}

/**
 * Frozen codec registry. Add new ids; never change existing payloads.
 * @type {Record<string, { encode: (project: object) => string, decode: (payload: string) => object }>}
 */
export const HANDOVER_CODECS = {
  /**
   * gzip-9 minified project JSON, base64url-encoded.
   */
  g9: {
    encode(project) {
      const json = JSON.stringify(project);
      const compressed = gzip(utf8Encode(json), { level: 9 });
      return encodeBase64Url(compressed);
    },
    decode(payload) {
      const bytes = decodeBase64Url(payload);
      const json = utf8Decode(ungzip(bytes));
      return JSON.parse(json);
    },
  },
};

export function getHandoverCodec(codecId) {
  const codec = HANDOVER_CODECS[codecId];
  if (!codec) {
    throw createCoreError("core.errors.unsupportedHandoverCodec", { codecId });
  }
  return codec;
}
